/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_EmptyInputs */

const vi_media_empty = /** @type {(inputs: Media_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thư viện chưa có ảnh nào. Bấm Tải lên để thêm ảnh hoặc video.`)
};

/**

* @param {Media_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_empty = /** @type {((inputs?: Media_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_empty(inputs)
});